var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowUpwardLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19618)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7 37.1V11.2H24.9V37.1H22.7Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1782 10.7676C23.0683 9.71227 24.6145 9.85888 25.4778 10.7222C25.484 10.7285 25.4902 10.7348 25.4963 10.7412L35.5963 21.3412L34.0036 22.8588L23.9166 12.2725C23.8836 12.2417 23.8497 12.2295 23.8263 12.2261C23.8153 12.2386 23.8041 12.2508 23.7926 12.2627L13.5926 22.8627L12.0073 21.3373L22.1782 10.7676Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6,
    height: 27.1,
    fill: "white",
    transform: "translate(12 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUpwardLight);
export default __webpack_public_path__ + "static/media/icon_arrow_upward_light.0938e94b.svg";
export { ForwardRef as ReactComponent };